import { useCallback, useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { colors, type, spacing, radius } from "@/theme";
import { api } from "@/lib/api";
import { useCustomer } from "@/context/CustomerContext";
import KdsTableCard from "@/components/KdsTableCard";

// Dopo un ordine nel menu dimostrativo: la vista KDS reale del tavolo del visitatore.
export default function DemoCucina() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [params] = useSearchParams();
  const o = params.get("o");
  const { session } = useCustomer();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => { document.title = "La cucina | Osteria del Borgo"; }, []);

  const load = useCallback(async () => {
    if (!session) return;
    try { setData(await api.demoKds(session.session_id)); } catch (e) { setError(e.message); }
  }, [session]);

  useEffect(() => {
    load();
    const poll = setInterval(load, 3000);
    return () => clearInterval(poll);
  }, [load]);

  return (
    <div style={{ minHeight: "100vh", background: colors.paper }}>
      <div style={{ width: "100%", maxWidth: 640, margin: "0 auto", padding: `${spacing.lg}px ${spacing.lg}px ${spacing.xl}px`, display: "flex", flexDirection: "column", gap: spacing.lg }}>
        <h1 style={{ ...type.serif, fontSize: 36, lineHeight: "40px", color: colors.ink, margin: 0 }}>Ecco cosa ha appena visto la cucina.</h1>

        <div data-testid="demo-kds" style={{ border: `1px solid ${colors.lineStrong}`, borderRadius: radius.md, background: colors.bg, overflow: "hidden" }}>
          <div style={{ padding: `${spacing.s12}px ${spacing.md}px`, borderBottom: `1px solid ${colors.line}` }}>
            <div style={{ ...type.sansBold, fontSize: 22, color: colors.ink }}>Cucina</div>
            <div style={{ ...type.sans, fontSize: 13, color: colors.inkMuted }}>{data?.tenant_nome || ""}</div>
          </div>
          {error ? <div style={{ ...type.sansMedium, fontSize: 14, color: colors.danger, padding: spacing.md }}>{error}</div>
            : !data ? <div style={{ padding: spacing.xl, textAlign: "center", ...type.sans, color: colors.ink }}>Caricamento…</div>
            : <div style={{ padding: spacing.md, display: "flex", flexDirection: "column", gap: spacing.md }}>
                {data.tables.map((t) => <KdsTableCard key={t.session_id} t={t} readOnly highlightOrderId={o} />)}
              </div>}
        </div>

        <p style={{ ...type.sans, fontSize: 18, lineHeight: "28px", color: colors.ink, margin: 0 }}>Nel tuo locale, questo compare sul tablet in cucina mentre il cliente è ancora seduto.</p>

        <button data-testid="demo-create-menu" onClick={() => navigate("/registrati")} style={{ background: colors.accent, minHeight: 56, border: "none", borderRadius: radius.md, color: colors.onAccent, ...type.sansSemi, fontSize: 17, padding: `0 ${spacing.lg}px` }}>Crea il tuo menu — è gratis</button>
        <button data-testid="demo-back-menu" onClick={() => navigate(`/m/${slug}/menu`, { replace: true })} style={{ background: "none", border: "none", minHeight: 44, ...type.sansMedium, fontSize: 15, color: colors.ink, textDecoration: "underline" }}>Torna al menu</button>
      </div>
    </div>
  );
}
